(function () {
  function initMission(section) {
    if (!section) return;

    // BUILD LETTERS (only once)
    var target = section.querySelector('[data-m-mission-letters]');
    if (target && !target.dataset.built) {
      var text = target.getAttribute('data-text') || '';
      var html = '';
      var index = 0;

      text.split(' ').forEach(function (word, wordIndex, words) {
        html += '<span class="m-word">';

        word.split('').forEach(function (char) {
          html += '<span class="m-char"><span class="m-char-inner" style="--char-index:' + index + ';">' + char + '</span></span>';
          index++;
        });

        html += '</span>';

        if (wordIndex < words.length - 1) {
          html += '<span class="m-char"><span class="m-char-inner" style="--char-index:' + index + ';">&nbsp;</span></span>';
          index++;
        }
      });

      target.innerHTML = html;
      target.dataset.built = 'true';
    }

    // FORCE RESET (important)
    section.classList.remove('is-visible');

    // FORCE REFLOW (animation restart trick)
    void section.offsetHeight;

    // SHOW WITH DELAY
    setTimeout(function () {
      section.classList.add('is-visible');
    }, 200);
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-m-mission]');
    sections.forEach(initMission);
  }

  // LOAD
  document.addEventListener('DOMContentLoaded', initAll);

  // SHOPIFY EDITOR FIX
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-m-mission]') || e.target;
    initMission(section);
  });

})();